import React, { useRef } from "react";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import {
  MAX_UPLOAD_FILE_ROWS,
  MAX_UPLOAD_FILE_SIZE_BYTES,
  MAX_UPLOAD_FILE_SIZE_MB,
} from "constants/constants";

import styles from "./FileUpload.module.scss";

const FileUpload = ({
  selectedFile,
  onFileChange,
  onFileError,
  disabled = false,
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = React.useState(false);

  const validateAndSelectFile = (file) => {
    if (!file || !onFileChange) {
      return;
    }

    if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      onFileError?.(`File size must be ${MAX_UPLOAD_FILE_SIZE_MB} MB or less.`);
      return;
    }

    onFileChange(file);
  };

  const handleFile = (file) => {
    validateAndSelectFile(file);
  };

  const handleInputChange = (event) => {
    handleFile(event.target.files?.[0]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    if (!disabled) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    if (!disabled) {
      handleFile(event.dataTransfer.files?.[0]);
    }
  };

  const openFilePicker = () => {
    if (!disabled) {
      fileInputRef.current?.click();
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div
        className={`${styles.dropZone} ${isDragging ? styles.dropZoneActive : ""} ${
          disabled ? styles.dropZoneDisabled : ""
        }`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={openFilePicker}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openFilePicker();
          }
        }}
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
      >
        <CloudUploadOutlinedIcon className={styles.uploadIcon} />

        {selectedFile ? (
          <div className={styles.selectedFile}>
            <InsertDriveFileOutlinedIcon className={styles.fileIcon} />
            <span className={styles.fileName}>{selectedFile.name}</span>
          </div>
        ) : (
          <>
            <p className={styles.dropTitle}>
              Drag &amp; Drop CSV file here or
            </p>
          </>
        )}

        <button
          type="button"
          className={styles.browseButton}
          onClick={(event) => {
            event.stopPropagation();
            openFilePicker();
          }}
          disabled={disabled}
        >
          Browse Files
        </button>

        <p className={styles.hint}>
          CSV only (.csv) &bull; Max no. of rows: {MAX_UPLOAD_FILE_ROWS}
        </p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        onChange={handleInputChange}
        className={styles.hiddenInput}
        disabled={disabled}
      />
    </div>
  );
};

export default FileUpload;
